import { createSelector } from 'reselect';
import fp from 'lodash/fp';

import { mappings } from './constants';

export const getColumns = fp.get('impactAnalysisIdSummaryGrid.columns');

export const combinedColumnsSelector = createSelector(
    getColumns,
    fp.map(column => ({
        ...column,
        ...mappings.find(col => col.id === column.id)
    }))
);

export const getRows = fp.get('impactAnalysisIdSummaryGrid.rows');

export const getInitialised = fp.get('impactAnalysisIdSummaryGrid.initialised');

export const getLastUpdated = fp.get('impactAnalysisIdSummaryGrid.lastUpdated');

export const getLoading = fp.get('impactAnalysisIdSummaryGrid.loading');

export const getDefaultSort = fp.get('impactAnalysisIdSummaryGrid.gridSorting');

export const getCurrentServerFilters = fp.get('impactAnalysisIdSummaryGrid.currentServerFilters');

export const getDateFrom = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'runDate');
        if (filter && filter.value) {
            return filter.value.from;
        }
    }
    return null;
};

export const getDateTo = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'runDate');
        if (filter && filter.value) {
            return filter.value.to;
        }
    }
    return null;
};

export const getUser = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'userName');
        if (filter) {
            return filter.value;
        }
    }
    return '';
};
